<div class="input-boolean-container" [class.disabled]="isDisabled" (click)="checkItem()">
	<label class="bl-template">
		<input
			type="checkbox"
			class="input-checkbox-boolean-component"
			#inputToogler
			[disabled]="isDisabled"
		/>
		<div class="input-boolean-component">
			<div class="bolinha"></div>
		</div>
	</label>
</div>
